export function formatNumber(value: number, lang: string): string {
  if (!Number.isFinite(value)) return String(value);
  try {
    // Latin digits in every locale, ar included (pinned, not left to CLDR).
    const tag = lang.includes("-u-") ? lang : `${lang}-u-nu-latn`;
    return new Intl.NumberFormat(tag).format(value);
  } catch {
    return String(value);
  }
}

/** Whole numbers: prices never show decimals. */
function formatWhole(value: number, lang: string): string {
  return formatNumber(Number.isFinite(value) ? Math.round(value) : value, lang);
}

export function formatPrice(value: number, currency: string, lang: string): string {
  return `${formatWhole(value, lang)} ${currency}`;
}

/**
 * Localized currency label. ISO code stays in en/fr; ar gets the Arabic name
 * since "MAD" reads as Latin glyphs inside Arabic copy.
 */
export function currencyLabel(currency: string, lang: string): string {
  if (currency !== "MAD") return currency;
  if (lang === "ar") return "درهم";
  return "MAD";
}

export function formatMad(value: number, lang: string): string {
  return `${formatWhole(value, lang)} ${currencyLabel("MAD", lang)}`;
}
